import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../api/client'
import { isCashReportEnabled, type CashReportConfig } from '../lib/cashReportFlag'

export function useCashReportFlag() {
  const q = useQuery({
    queryKey: ['app-config'],
    queryFn: () => apiFetch<CashReportConfig>('GET', '/api/config'),
    staleTime: 60_000,
  })
  return {
    enabled: isCashReportEnabled(q.data),
    loading: q.isPending,
  }
}
